import { writable } from 'svelte/store';

/** @type {import('svelte/store').Writable<boolean>} */
export const showAiChatDrawer = writable(false);

/**
 * @typedef {'user' | 'agent' | 'status' | 'error'} AiChatMessageRole
 * @typedef {object} AiChatMessage
 * @property {string} id
 * @property {AiChatMessageRole} role
 * @property {string} text
 * @property {string} [href]
 */

/** @type {import('svelte/store').Writable<AiChatMessage[]>} */
export const aiChatMessages = writable([]);

/** @type {import('svelte/store').Writable<boolean>} */
export const aiChatBusy = writable(false);

/** @type {import('svelte/store').Writable<string | undefined>} */
export const aiChatTaskId = writable(undefined);

/** @type {import('svelte/store').Writable<string | undefined>} */
export const aiChatSessionUrl = writable(undefined);

const TASK_ID_KEY = 'gitbase-ai-agent.taskId';

/** @returns {string | undefined} */
export const loadStoredTaskId = () => {
  try {
    return sessionStorage.getItem(TASK_ID_KEY) ?? undefined;
  } catch {
    return undefined;
  }
};

/** @param {string | undefined} taskId */
export const storeTaskId = (taskId) => {
  try {
    if (taskId) {
      sessionStorage.setItem(TASK_ID_KEY, taskId);
    } else {
      sessionStorage.removeItem(TASK_ID_KEY);
    }
  } catch {
    //
  }
};

/** @param {AiChatMessageRole} role @param {string} text @param {string} [href] */
export const appendAiChatMessage = (role, text, href = undefined) => {
  aiChatMessages.update((messages) => [
    ...messages,
    {
      id: `${Date.now()}-${messages.length}`,
      role,
      text,
      href,
    },
  ]);
};

export const resetAiChatSession = () => {
  aiChatMessages.set([]);
  aiChatTaskId.set(undefined);
  aiChatSessionUrl.set(undefined);
  storeTaskId(undefined);
};
